import React from "react";
import { Redirect } from 'react-router-dom';
import { Link } from 'react-router-dom'

const DevList = ({data, isLoading}) => {
  //console.log(data)
  //Test empty object
  if (Object.keys(data).length === 0) return null
  
  const devRows = data.rows
  //console.log(devRows)
  //if (!data) return null
  return (
    <div className="container mt-1">
      <h4 className="text-info">Device List {`${isLoading?'...':''}`}</h4>
    <table className="table table-striped">
        <thead>
            <tr className="text-secondary">
                <th>dev</th>
                <th>Name (online <span className="text-info">co</span><span className="text-danger">lo</span><span className="text-warning">ur</span>)</th>
                <th>Type</th>
                <th>Sensors</th>
                <th>Actions</th>
                <th>States</th>
                <th>Events</th>
                <th>Alarm</th>

            </tr>
        </thead>
        <tbody>
          {
            devRows.map((v,i) => {
              return (
                <tr key={`dev_${v.id}`} className="text-secondary">
                <td><Link to={`/selected_device/${v.id}`}>{v.id}</Link></td>
                <td><Link to={`/selected_device/${v.id}`}>{onlineDecor(v.name, v.online_state)}</Link></td>
                {/* <td>{onlineDecor(v.name, v.online_state)}</td> */}
                <td>{v.type}</td>
                <td>{v.qty_sensors}</td>
                <td>{v.qty_actions}</td>
                <td>{v.qty_states}</td>
                <td>{v.qty_events}</td>
                <td>-</td>
    
              </tr>
              )
            })
          }

        </tbody>
    </table>
</div>
  )
}

export default DevList;

const onlineDecor = (iStr, onlineValue) => {
  if (onlineValue === 1) return <span className="text-info">{iStr}</span>
  if (onlineValue === 0) return <span className="text-danger">{iStr}</span>
  if (onlineValue === null) return <span className="text-warning">{iStr}</span>

}